// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"clubEdit__gradient-bg5__S7pLe","section":"clubEdit__section__rAkEg","clubName":"clubEdit__clubName__cwpQm"};